<template>
  <div class="ensure-income-list-container">
    <el-tabs v-model="scopeType" :stretch="false" @tab-click="handleChange">
      <el-tab-pane :label="tab.label" :name="tab.name" v-for="(tab) in scopeTabs" :key="tab.name"></el-tab-pane>
    </el-tabs>

    <!--   待确认列表：全部、经纪人、转交人 -->
    <ConfirmTable ref="refConfirmTable" v-if="scopeTabs.length>0"></ConfirmTable>
  </div>
</template>

<script>

import ConfirmTable from "@/views/adOrder/income_summary/agent_confirm/components/ConfirmTable.vue";

export default {
  name: "incomeEnsure",
  components: {ConfirmTable},
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  data() {
    return {
      scopeType: '',//数据范围
      scopeTabs: [
        {'label': '全部', 'name': 'all', 'auth': 'ensure_income_scope_all'},
        {'label': '我负责的', 'name': 'mine', 'auth': 'ensure_income_scope_agent'},
        {'label': '转交我的', 'name': 'toMe', 'auth': 'ensure_income_scope_assistant'},
      ]
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleChange(tab, event) {
      this.handleQuery()
    },
    handleQuery() {
      if (this.$refs['refConfirmTable'])
        this.$refs['refConfirmTable'].open(this.scopeType)
    },
    calcTabs() {
      const permissions = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : {}
      this.scopeTabs = []
      if (permissions['ensure_income_scope_all']) {
        this.scopeTabs.push({'label': '全部', 'name': 'all', 'auth': 'ensure_income_scope_all'})
      }

      if (permissions['ensure_income_scope_agent']) {
        this.scopeTabs.push({'label': '我负责的', 'name': 'mine', 'auth': 'ensure_income_scope_agent'})
      }

      if (permissions['ensure_income_scope_assistant']) {
        this.scopeTabs.push({'label': '转交我的', 'name': 'toMe', 'auth': 'ensure_income_scope_assistant'})
      }

      //默认显示tab
      const len = this.scopeTabs.length
      if (len > 0 && this.scopeTabs[0]) {
        this.scopeType = this.scopeTabs[0]['name']
        this.handleQuery()
      }

    }
  },
  mounted() {
    this.calcTabs()
  }
}
</script>

<style lang="scss">
.ensure-income-list-container {
  padding: 5px 10px;
  height: calc(100vh - 166px);

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr,
  .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }

  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}
</style>
